import api from '@/api'

export const sendQuestion = async (conversationId, FAQId, FAQIndex) => {
  const url = '/v2/messages/FAQ'
  const method = 'post'
  const resp = await api.asyncRequest(url, method, { conversationId, FAQId, FAQIndex })
  if (resp.ok && resp.data) return resp.data
  else return Promise.reject(resp.data)
}

export const fetchConversation = async () => {
  const url = `/v2/messages/conversations?isVisitor=${true}`
  const method = 'get'
  const resp = await api.asyncRequest(url, method)
  if (resp.ok && resp.data) return resp.data
  else return Promise.reject(resp.data)
}
